<template>
  <el-card class="h-full">
    <div class="h-full flex flex-col">
      <span
        v-if="!(formProps.editType === 'read')"
        class="border-l-3 border-color-primary pl-10px text-18px"
        >设备设施危险源编辑</span
      >
      <div v-else>
        <el-page-header @back="$emit('cancel')" content="设备设施危险源详情"></el-page-header>
      </div>
      <div class="flex-1 overflow-y-auto mt-20px">
        <el-collapse v-model="collapseActiveName">
          <el-collapse-item title="风险点基本信息" name="baseInfo">
            <el-form
              v-loading="loading"
              ref="controlForm"
              label-width="150px"
              :model="controlForm"
              disabled
            >
              <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="设备设施名称" prop="name">
                    <el-input
                      v-model="pointInfo.name"
                      placeholder="请输入设备设施名称"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="设备设施编号" prop="no">
                    <el-input
                      v-model="pointInfo.no"
                      placeholder="请输入设备设施编号"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="危险介质" prop="hazardousMedia">
                    <el-input
                      v-model="pointInfo.hazardousMedia"
                      placeholder="请输入危险介质"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="所属区域" prop="areaText">
                    <el-input
                      v-model="pointInfo.areaText"
                      placeholder="请输入所属区域"
                      maxlength="50"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="所属单位" prop="ownedUnit">
                    <el-input
                      v-model="pointInfo.ownedUnit"
                      placeholder="请输入所属单位"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="kks编码" prop="kksNo">
                    <el-input
                      v-model="pointInfo.kksNo"
                      placeholder="请输入kks编码"
                      maxlength="50"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="设备类别" prop="typeText">
                    <el-input
                      v-model="pointInfo.typeText"
                      placeholder="请输入设备类别"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="是否特种设备" prop="isSpecial">
                    <el-input
                      v-model="pointInfo.isSpecial"
                      placeholder="请选择是否属于特种设备"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item
                    label="管控层级"
                    prop="controlHierarchy"
                    :rules="[
                      {
                        required: true,
                        message: '请输入管控层级',
                        trigger: ['blur', 'change'],
                      },
                    ]"
                  >
                    <el-select
                      class="w-full"
                      placeholder="请输入管控层级"
                      v-model="controlForm.controlHierarchy"
                      clearable
                    >
                      <el-option
                        v-for="item in controlHierarchyList"
                        :key="item.code"
                        :label="item.displayName"
                        :value="Number(item.code)"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item
                    ref="departmentSelect"
                    label="责任部门"
                    prop="organizationUnitId"
                    :rules="[
                      {
                        required: true,
                        message: '请输入责任部门',
                        trigger: ['blur', 'change'],
                      },
                    ]"
                  >
                    <department-select
                      v-model="controlForm.organizationUnitId"
                      :disabled="formProps.editType === 'read'"
                      @change="changeDepartment"
                    ></department-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item
                    label="责任人"
                    prop="leaderId"
                    :rules="[
                      {
                        required: true,
                        message: '请输入责任人',
                        trigger: ['blur', 'change'],
                      },
                    ]"
                  >
                    <el-select
                      v-model="controlForm.leaderId"
                      class="w-full"
                      placeholder="请选择责任人"
                      clearable
                      filterable
                      :disabled="formProps.editType === 'read'"
                    >
                      <el-option
                        v-for="item in userList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item
                    label="值班电话"
                    prop="dutyPhone"
                    :rules="[
                      {
                        pattern: /^1[3-9]{1}[0-9]{9}$/,
                        message: '请输入正确值班电话',
                        trigger: ['blur', 'change'],
                      },
                    ]"
                  >
                    <el-input
                      v-model="controlForm.dutyPhone"
                      placeholder="请选择值班电话"
                      maxlength="50"
                      clearable
                      :disabled="formProps.editType === 'read'"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item
                    label="应急电话"
                    prop="emergencyPhone"
                    :rules="[
                      {
                        pattern: /^1[3-9]{1}[0-9]{9}$/,
                        message: '请输入正确应急电话',
                        trigger: ['blur', 'change'],
                      },
                    ]"
                  >
                    <el-input
                      v-model="controlForm.emergencyPhone"
                      placeholder="请选择应急电话"
                      maxlength="50"
                      clearable
                      :disabled="formProps.editType === 'read'"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-collapse-item>
        </el-collapse>
        <BankCollapseList
          :evaluateMethod="formData.evaluateMethod"
          :list="formData.equipmentFacilitySourcesDangerIdentifyAssessDtos"
        />
      </div>
      <div class="flex justify-center mt-20px" v-if="formProps.editType !== 'read'">
        <el-button @click="$emit('cancel')" size="small">取消</el-button>
      </div>
    </div>
  </el-card>
</template>

<script>
import { EafOrganizationUnitUserApi } from '@wiz-api/account'
import DepartmentSelect from '@/components/safety/DepartmentSelect/DepartmentSelect'
import utils from '@/components/safety/enumField/utils'
import { EquipmentFacilitySourcesDangerIdentifyApi } from '@wiz-api/double-prevention-management'
import BankCollapseList from '../business/BankCollapseList'

const equipmentFacilitySourcesDangerIdentifyApi = new EquipmentFacilitySourcesDangerIdentifyApi()
const eafOrganizationUnitUserApi = new EafOrganizationUnitUserApi()
export default {
  name: 'bank-equip-form',
  components: {
    // SelectCheckItems,
    BankCollapseList,
    DepartmentSelect,
  },
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
    formProps: {
      default: () => {
        return {
          title: '',
          editType: 'create',
          visible: true,
        }
      },
    },
  },
  data() {
    return {
      controlForm: {
        controlHierarchy: '',
        organizationUnitId: '',
        leaderId: '',
        dutyPhone: '',
        emergencyPhone: '',
      },
      showDialog: false,
      taskList: [1, 2],
      tableData: [],
      list: [],
      loading: false,
      collapseActiveName: ['baseInfo', 'risk'],
      accidentTypeList: [],
      controlHierarchyList: [],
      userList: [],
      pointInfo: {
        areaText: '',
        hazardousMedia: '',
        isSpecial: '',
        name: '',
        ownedUnit: '',
        typeText: '',
        kksNo: '',
      },
    }
  },
  watch: {},
  created() {
    utils.getDataCategory(
      ['DoublePreventionManagement.DataCategory.ControlHierarchy'],
      ['controlHierarchyList'],
      this
    )
    // 获取责任人
    Object.keys(this.controlForm).forEach((key) => {
      this.controlForm[key] = this.formData[key]
    })
    if (this.formData.equipmentFacilityId) {
      this.getPointInfo(this.formData.equipmentFacilityId)
    }
    this.getUserList()
  },
  mounted() {},

  methods: {
    // 获取设备基本信息
    async getPointInfo(id) {
      this.loading = true
      const [err, res] = await equipmentFacilitySourcesDangerIdentifyApi.getEquipmentFacilityInfo(
        id
      )
      if (!err) {
        const { creationTime, ...otherData } = res
        this.pointInfo = {
          ...otherData,
        }
      }
      this.loading = false
    },
    // 切换责任部门
    changeDepartment(val) {
      this.$refs.departmentSelect.$emit('el.form.change')
      if (val) {
        this.getUserList()
        this.controlForm.leaderId = undefined
      } else {
        this.controlForm.leaderId = undefined
        this.userList = []
      }
    },
    // 获取用户列表
    async getUserList() {
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserList({
        organizationUnitId: this.formData.responsibleDepartment,
        includeOrgChild: true, // 是否查询该部门子部门人员
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.userList = res.items
      }
    },
    createRow() {
      this.$refs.controlMeasure.createRow()
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-icon-arrow-right {
  display: none;
}
</style>
